export const scrollContainerToBottom = (container: HTMLElement, behavior: ScrollBehavior) => {
  container.scrollTo({ top: container.scrollHeight, behavior });
};
